import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, Store} from '@ngxs/store';
import {
  DecrementExploreStep,
  IncrementExploreStep,
  InitForm,
  InitFormFail,
  InitFormSuccess,
  UpdateData,
  UpdateExploreStep
} from './explore.actions';
import {AssessmentService} from '../../services/assessment.service';
import {Logout} from '../../../auth/states/auth/auth.actions';
import {BackendError} from '../../../messages/messages.actions';
import {ExploreStateModel} from './explore.models';


const STATE_DEFAULTS: ExploreStateModel = {
  form: null,
  step: 0,
  loading: false,
  loaded: false,
};

@State<ExploreStateModel>({
  name: 'dashboard_explore',
  defaults: STATE_DEFAULTS
})

@Injectable()
export class ExploreState {
  constructor(private store: Store, private assessmentService: AssessmentService) {
  }

  @Selector()
  static exploreData(state: ExploreStateModel): any {
    return state.form;
  }

  @Selector()
  static isLoading(state: ExploreStateModel): boolean {
    return state.loading;
  }

  @Selector()
  static isLoaded(state: ExploreStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static step(state: ExploreStateModel): number {
    return state.step;
  }

  @Action(InitForm)
  initForm({getState, patchState, dispatch}: StateContext<ExploreStateModel>, {formConfig}: InitForm) {
    patchState({
      loading: true,
      loaded: false,
    });

    this.assessmentService.retrieveExplore().subscribe(
      data => dispatch(new InitFormSuccess(data['explore_data'], formConfig)),
      err => dispatch(new InitFormFail(err))
    );
  }

  @Action(InitFormSuccess)
  initFormSuccess({patchState}: StateContext<ExploreStateModel>, {payload, formConfig}: InitFormSuccess) {
    let step = 0;
    if (payload && formConfig) {
      for (const line of formConfig) {
        if (line.name in payload) {
          step++;
        } else {
          break;
        }
      }
    }

    patchState({
      loading: false,
      loaded: true,
      form: payload,
      step
    });
  }

  @Action(InitFormFail)
  initFormFail({patchState, dispatch}: StateContext<ExploreStateModel>, {err}: InitFormFail) {
    patchState({
      loading: false,
      loaded: false
    });
    dispatch(new BackendError(err));
  }

  @Action(UpdateData)
  updateData({dispatch}: StateContext<ExploreStateModel>, {payload}: UpdateData) {
    this.assessmentService.updateExplore(payload).subscribe(
      () => {
      },
      err => dispatch(new BackendError(err)),
    );
  }

  @Action(IncrementExploreStep)
  incrementStep(ctx: StateContext<ExploreStateModel>) {
    const state = ctx.getState();
    ctx.patchState({step: state.step + 1});
  }

  @Action(DecrementExploreStep)
  decrementStep(ctx: StateContext<ExploreStateModel>) {
    const state = ctx.getState();
    ctx.patchState({step: state.step - 1});
  }

  @Action(UpdateExploreStep)
  updateStep({patchState}: StateContext<ExploreStateModel>, {payload}: UpdateExploreStep) {
    patchState({step: payload});
  }

  @Action(Logout)
  logout({setState}: StateContext<ExploreStateModel>) {
    setState(STATE_DEFAULTS);
  }
}
